// extracted by mini-css-extract-plugin
export default {"settings_dialog_body":"EntityListSettingsDialog_settings_dialog_body__5MSeT","settings_group_container":"EntityListSettingsDialog_settings_group_container__67Zob"};